const MORNING_START_HOUR = 5;
const AFTERNOON_START_HOUR = 12;
const EVENING_START_HOUR = 18;

const FALLBACK_FIRST_NAME = 'você';

export function getGreeting(date: Date = new Date()): string {
  const hour = date.getHours();

  if (hour >= MORNING_START_HOUR && hour < AFTERNOON_START_HOUR) return 'Bom dia';
  if (hour >= AFTERNOON_START_HOUR && hour < EVENING_START_HOUR) return 'Boa tarde';

  return 'Boa noite';
}

export function getFirstName(fullName?: string): string {
  return (fullName ?? '').trim().split(/\s+/)[0] || FALLBACK_FIRST_NAME;
}

export function formatToday(date: Date = new Date()): string {
  const label = date.toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
  });

  return label.charAt(0).toUpperCase() + label.slice(1);
}
